import { Box } from 'braid-design-system';
import React from 'react';

import * as styles from './index.css';

interface Props {
  customStyle?: string;
  imageUrl: string;
}

export const PanelImage = ({ customStyle, imageUrl }: Props) => (
  <Box
    className={[styles.panelImageStyle, customStyle]}
    style={{ backgroundImage: `url(${imageUrl})` }}
  />
);
